import colors from "../../base/colors";
import pxToRem from "../../functions/pxToRem";
import rgba from "../../functions/rgba";

const { primary, inputBorderColor, text, grey, error } = colors;

const input = {
  styleOverrides: {
    root: {
      fontSize: pxToRem(14),
      color: text.main,

      "&:hover:not(.Mui-disabled):before": {
        borderBottom: `1px solid ${grey[400]}`,
      },

      "&:before": {
        borderColor: rgba(inputBorderColor, 0.6),
        transition: "border-bottom-color 0.12s ease",
      },

      "&:after": {
        borderColor: primary.main,
        borderWidth: "2px",
      },

      "&.Mui-error": {
        "&:after": {
          borderColor: error.main,
        },
      },
    },

    input: {
      color: text.main,
      padding: `${pxToRem(6)} 0`,
      fontSize: pxToRem(14),
      lineHeight: "20px",

      "&::placeholder": {
        color: grey[400],
        opacity: 1,
      },

      "&:focus": {
        outline: "none",
      },
    },

    inputSizeSmall: {
      padding: `${pxToRem(6)} 0`,
      fontSize: pxToRem(14),
    },
  },
};

export default input;
